export enum PAGE_TYPE {
    PDP = "Product Detail Page",
    LISTING = "listing page",
    SEARCH = "Search Page",
    HOMEPAGE = "home page",
    OFFERPAGE = "offer page",
}

export enum EVENTS {
    PDP = "product-detail-rule",
    LISTING = "listing-page-rule",
    SEARCH = "searchPage",
    HOMEPAGE = "homepage",
    OFFERPAGE = "offerpage",
}

export enum USER_STATUS {
    GUEST = "guest",
    LOGGED_IN = "logged in",
}

export const DEFAULT_CHANNEL = "NDS";
export const DEFAULT_CURRENCY = "INR";
export const REACT_IDENTIFIER = "react";
